export enum MeterStateEnums {
    open = 1,
    closed = 2
}